(() => {
  function initSidebarMetaobject(section) {
    if (!section) return;

    // Prevent duplicate event listeners
    if (section.dataset.sidebarMetaobjectInitialized === 'true') return;

    section.dataset.sidebarMetaobjectInitialized = 'true';

    const buttons = section.querySelectorAll('[data-metaobject-scroll-to]');
    const content = section.querySelector('.section-sidebar__content');

    if (!buttons.length || !content) return;

    const openFirstAccordion =
      section.dataset.openFirstAccordion === 'true';

    const items = Array.from(buttons)
      .map((button) => {
        const selector = button.getAttribute('data-metaobject-scroll-to');
        const target = section.querySelector(selector);

        if (!target) return null;

        return {
          button,
          target
        };
      })
      .filter(Boolean);

    function setActiveButton(activeButton) {
      buttons.forEach((button) => {
        button.classList.toggle(
          'is-selected',
          button === activeButton
        );
      });
    }

    function getHeaderOffset() {
      return 100;
    }

    function scrollToTarget(target) {
      setTimeout(() => {
        const targetPosition =
          target.getBoundingClientRect().top +
          window.scrollY -
          getHeaderOffset();

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }, 250);
    }

    // Open first accordion by default
    // Controlled by section setting
    if (openFirstAccordion) {
      const firstAccordion = content.querySelector(
        'details[data-collapsible]'
      );

      if (
        firstAccordion &&
        !firstAccordion.hasAttribute('open')
      ) {
        const trigger = firstAccordion.querySelector(
          '[data-collapsible-trigger]'
        );

        trigger?.click();
      }
    }

    // Sidebar button click
    items.forEach(({ button, target }) => {
      button.addEventListener('click', () => {
        setActiveButton(button);

        const accordion =
          target.nextElementSibling?.matches('details')
            ? target.nextElementSibling
            : null;

        // Open first accordion under this heading
        if (
          accordion &&
          !accordion.hasAttribute('open')
        ) {
          const trigger = accordion.querySelector(
            '[data-collapsible-trigger]'
          );

          trigger?.click();
        }

        scrollToTarget(target);
      });
    });

    // Accordion click -> update sidebar underline
    items.forEach(({ button, target }, index) => {
      const nextTarget = items[index + 1]?.target || null;

      let element = target.nextElementSibling;

      while (element && element !== nextTarget) {
        if (element.matches('details')) {
          const trigger = element.querySelector(
            '[data-collapsible-trigger]'
          );

          if (trigger) {
            trigger.addEventListener('click', () => {
              setActiveButton(button);
            });
          }
        }

        element = element.nextElementSibling;
      }
    });

    // Manual scroll -> update sidebar underline
    let ticking = false;

    function updateActiveOnScroll() {
      const offset = getHeaderOffset() + 40;

      let activeItem = items[0];

      items.forEach((item) => {
        const top = item.target.getBoundingClientRect().top;

        if (top <= offset) {
          activeItem = item;
        }
      });

      if (activeItem) {
        setActiveButton(activeItem.button);
      }

      ticking = false;
    }

    function onScroll() {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(updateActiveOnScroll);
    }

    window.addEventListener('scroll', onScroll, {
      passive: true
    });

    // Set initial active state
    updateActiveOnScroll();
  }

  function initAllSidebarMetaobjects() {
    document
      .querySelectorAll(
        '[data-section-type="sidebar-metaobject"]'
      )
      .forEach((section) => {
        initSidebarMetaobject(section);
      });
  }

  // Normal page load
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllSidebarMetaobjects
    );
  } else {
    initAllSidebarMetaobjects();
  }

  // Shopify Theme Editor reload
  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section = event.target.matches?.(
        '[data-section-type="sidebar-metaobject"]'
      )
        ? event.target
        : event.target.querySelector?.(
            '[data-section-type="sidebar-metaobject"]'
          );

      if (section) {
        initSidebarMetaobject(section);
      }
    }
  );
})();